import { render } from "./DefaultExpandedAndDefaultChecked.vue?vue&type=template&id=e674af22"
import script from "./DefaultExpandedAndDefaultChecked.vue?vue&type=script&lang=ts"
export * from "./DefaultExpandedAndDefaultChecked.vue?vue&type=script&lang=ts"
script.render = render

export default script